"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withNumberFormat = exports.withDecimalFormat = exports.withCardNumberFormat = exports.withCardDateFormat = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _rifm = require("rifm");
var _userflow = require("../utils/userflow");
var _excluded = ["accept", "format", "parseValue", "append"],
  _excluded2 = ["value", "onChange"];
var INT_REGEXP = /\d+/g;
var parseDigits = function parseDigits() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (string.match(INT_REGEXP) || []).join('');
};

/**
 * Returns for matted card number
 * @param {*} string unformatted string
 *
 * @return formatted card number, ie:
 * 00001111 -> 0000 1111
 * 000011112222333333 -> 0000 1111 2222 333333
 */
var formatCreditCard = function formatCreditCard(string) {
  var parsed = parseDigits(string);
  var formatted = parsed.split('').reduce(function (res, curr, idx) {
    res.push(curr);

    // up to 4 groups by 4, then larger group last
    var shouldAddDelimeter = (idx + 1) % 4 === 0 && idx <= 12;
    if (shouldAddDelimeter) {
      res.push(' ');
    }
    return res;
  }, []).join('');
  return formatted;
};
var formatDate = function formatDate(string) {
  var digits = parseDigits(string);
  return digits.split('').reduce(function (r, v, index) {
    return index === 2 ? "".concat(r, "/").concat(v) : "".concat(r).concat(v);
  }, '').substr(0, 5);
};
var formatPrice = function formatPrice(value) {
  return (0, _isEmpty2["default"])(value) ? '' : (0, _userflow.formatDecimal)(parseDigits(value));
};
var formatDateWithAppend = function formatDateWithAppend(string) {
  var res = formatDate(string);
  if (string.endsWith('/')) {
    if (res.length === 2) {
      return "".concat(res, "/");
    }
  }
  return res;
};
var withRifmFormat = function withRifmFormat(WrappedComponent, _ref) {
  var accept = _ref.accept,
    format = _ref.format,
    parseValue = _ref.parseValue,
    append = _ref.append,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return function (_ref2) {
    var value = _ref2.value,
      onChange = _ref2.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(_rifm.Rifm, (0, _extends2["default"])({
      accept: accept,
      format: format,
      value: value,
      append: append,
      onChange: parseValue ? function (v) {
        return onChange(parseValue(v));
      } : onChange
    }, rest), function (_ref3) {
      var value = _ref3.value,
        onChange = _ref3.onChange;
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
        value: value,
        onChange: onChange
      }, props));
    });
  };
};
var withNumberFormat = exports.withNumberFormat = function withNumberFormat(WrappedComponent) {
  return withRifmFormat(WrappedComponent, {
    accept: INT_REGEXP,
    format: parseDigits,
    parseValue: parseDigits
  });
};
var withCardNumberFormat = exports.withCardNumberFormat = function withCardNumberFormat(WrappedComponent) {
  return withRifmFormat(WrappedComponent, {
    accept: INT_REGEXP,
    format: formatCreditCard,
    parseValue: parseDigits,
    mask: true
  });
};
var withCardDateFormat = exports.withCardDateFormat = function withCardDateFormat(WrappedComponent) {
  return withRifmFormat(WrappedComponent, {
    accept: INT_REGEXP,
    format: formatDateWithAppend,
    mask: true,
    append: function append(v) {
      return v.length === 2 ? "".concat(v, "/") : v;
    }
  });
};
var withDecimalFormat = exports.withDecimalFormat = function withDecimalFormat(WrappedComponent) {
  return withRifmFormat(WrappedComponent, {
    accept: INT_REGEXP,
    format: formatPrice,
    parseValue: parseDigits
  });
};
var _default = exports["default"] = withRifmFormat;